import { Controller } from '@hotwired/stimulus';

export default class RowSelectionController extends Controller {
  static targets = [
    'checkbox',
    'radio',
    'label'
  ];

  toggleCheckbox(e) {
    if (e.target === this.checkboxTarget) return;
    if (this.hasLabelTarget && e.target === this.labelTarget) return;
    if (this.checkboxTarget.disabled) return;
    if (this.element.classList.contains('unhover')) return;

    this.checkboxTarget.checked = !this.checkboxTarget.checked;

    this.dispatch('toggleCheckbox');
  }

  toggleRadio(e) {
    if (e.target === this.radioTarget) return;
    if (this.hasLabelTarget && e.target === this.labelTarget) return;
    if (this.radioTarget.disabled) return;
    if (this.element.classList.contains('unhover')) return;

    this.radioTarget.checked = true;

    this.dispatch('toggleRadio');
  }
}
